import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection, LegalDisclaimer, LegalLastUpdated } from '../LegalLayout';
import { APP_NAME } from '../../config/branding';
import { MIN_AGE_YEARS } from '../legalConstants';

export default function CodeOfConductPage() {
  return (
    <LegalLayout
      title="Code of Conduct"
      subtitle={`Community standards for participating respectfully on ${APP_NAME}.`}
    >
      <LegalLastUpdated />

      <LegalSection title="Our commitment">
        <p>
          {APP_NAME} exists to foster thoughtful conversation. Every member — regardless of background, belief, or
          experience — deserves to participate without harassment, discrimination, or intimidation. This Code of Conduct
          applies to all areas of the platform, including discussions, clubs, stories, messages, and profiles (personal
          and social).
        </p>
      </LegalSection>

      <LegalSection title="Expected behavior">
        <ul>
          <li>Be respectful and assume good faith in disagreements</li>
          <li>Stay on topic in clubs and threads; use appropriate spaces for different subjects</li>
          <li>Give credit when sharing others&apos; ideas, quotes, or media</li>
          <li>Respect privacy — do not share private information about others without consent</li>
          <li>Use your profile identities thoughtfully; do not impersonate others</li>
          <li>Report violations rather than retaliating or escalating publicly</li>
        </ul>
      </LegalSection>

      <LegalSection title="Unacceptable behavior">
        <ul>
          <li>Harassment, bullying, stalking, or targeted abuse</li>
          <li>Hate speech or content promoting violence against individuals or groups</li>
          <li>Sexual content involving minors, or any exploitation of children (zero tolerance)</li>
          <li>Threats, doxing, or sharing personal contact information to harm someone</li>
          <li>Spam, scams, phishing, or deceptive manipulation</li>
          <li>Deliberate misinformation intended to cause harm (where identifiable)</li>
          <li>Disruptive trolling, brigading, or coordinated abuse</li>
          <li>Uploading malware or attempting to compromise platform security</li>
        </ul>
      </LegalSection>

      <LegalSection title="Age requirement">
        <p>
          All participants must be at least {MIN_AGE_YEARS} years old. Content must be appropriate for a general
          community audience unless clearly marked and permitted within a restricted club context governed by additional
          rules and moderation.
        </p>
      </LegalSection>

      <LegalSection title="Enforcement">
        <p>
          Violations may result in content removal, feature restrictions, temporary suspension, or permanent account
          termination — at our discretion. Severe violations may be reported to relevant authorities. We may act on reports
          even if the reported user claims no harm was intended.
        </p>
        <p>
          To report a concern, see <Link to="/legal/safety" className="legal-inline-link">Safety & Reporting</Link> or
          email {' '} 
          {/* <a href={`mailto:${SUPPORT_EMAIL}`} className="legal-inline-link">{SUPPORT_EMAIL}</a>. */}
          <Link to="/contact" className="legal-inline-link">Contact</Link> form.
        </p>
      </LegalSection>

      <LegalSection title="Appeals">
        <p>
          If you believe enforcement action was taken in error, plesae contact us via the {' '}
          <Link to="/contact" className="legal-inline-link">Contact</Link> form, a description
          of the action, and why you believe it should be reversed. We review appeals in good faith but are not obligated
          to reinstate content or accounts.
        </p>
      </LegalSection>

      <LegalDisclaimer />
    </LegalLayout>
  );
}
